import { BrandKitContentLabResponse } from '@goldcast/api/backend';

import { BrandKitState } from './types';
import { getFormattedBrandKitBackground, getFormattedBrandKitFonts } from './util';

const mutations = {
  async setBrandKit(state: BrandKitState, payload: { brandKit: BrandKitContentLabResponse[]; orgId: string }) {
    if (payload.brandKit.length) {
      state.isLoaded = true;
      state.colors = payload.brandKit[0].colors ?? [];
      state.background = getFormattedBrandKitBackground(payload.brandKit[0].background ?? [], payload.orgId);
      state.fonts = await getFormattedBrandKitFonts(payload.brandKit[0].fonts ?? [], payload.orgId);
    }
  },
  setFontFailedToLoad(state: BrandKitState, fontUrl: string) {
    state.fontsFailedToLoad[fontUrl] = true;
  }
};

export type BrandKitMutations = typeof mutations;

export default mutations;
